/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FilesCreateUploadSessionBodyParams } from '../models/FilesCreateUploadSessionBodyParams';
import type { FilesCreateUploadSessionResponse } from '../models/FilesCreateUploadSessionResponse';
import type { FilesDeleteResponse } from '../models/FilesDeleteResponse';
import type { FilesFinalizeUploadSessionResponse } from '../models/FilesFinalizeUploadSessionResponse';
import type { FilesGetResponse } from '../models/FilesGetResponse';
import type { FilesListResponse } from '../models/FilesListResponse';
import type { FilesUpdateBodyParams } from '../models/FilesUpdateBodyParams';
import type { FilesUpdateResponse } from '../models/FilesUpdateResponse';
import type { FilesUploadBodyParams } from '../models/FilesUploadBodyParams';
import type { FilesUploadResponse } from '../models/FilesUploadResponse';
import type { TCFileStatus } from '../models/TCFileStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FilesService {
    /**
     * List files with support for filtering and pagination.
     *
     * Returns a paginated list of files. Supports filtering by status, content type, tags,
     * and other criteria.
     *
     * **Example usage:**
     * GET /api/v1/files?status=ready&contentType=image/jpeg&limit=20
     * @param limit Maximum number of items to return
     * @param pageToken Page token for pagination
     * @param status Filter by file status
     * @param createdAfter Filter by creation date (after)
     * @param createdBefore Filter by creation date (before)
     * @param lastAccessedAfter Filter by last accessed date (after)
     * @param tags Optional metadata tags filter as JSON string
     * Example: '{"category":"document","processed":"true"}'
     * @returns FilesListResponse Ok
     * @throws ApiError
     */
    public static getFiles(
        limit?: number,
        pageToken?: string,
        status?: TCFileStatus,
        createdAfter?: string,
        createdBefore?: string,
        lastAccessedAfter?: string,
        tags?: string,
    ): CancelablePromise<FilesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'status': status,
                'createdAfter': createdAfter,
                'createdBefore': createdBefore,
                'lastAccessedAfter': lastAccessedAfter,
                'tags': tags,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload a new file.
     *
     * Uploads a new file to the files service. The file content should be provided
     * as base64 encoded data along with metadata such as filename and content type.
     *
     * **Example usage:**
     * POST /api/v1/files
     * {
         * "fileName": "document.pdf",
         * "contentType": "application/pdf",
         * "content": "base64encodedcontent...",
         * "tags": { "source": "user_upload" }
         * }
         * @param requestBody
         * @returns FilesUploadResponse Ok
         * @throws ApiError
         */
        public static uploadFile(
            requestBody: FilesUploadBodyParams,
        ): CancelablePromise<FilesUploadResponse> {
            return __request(OpenAPI, {
                method: 'POST',
                url: '/api/files',
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    401: `Unauthorized`,
                    403: `Forbidden`,
                    500: `Internal Server Error`,
                },
            });
        }
        /**
         * Get a file by ID.
         *
         * Retrieves a single file by its unique identifier, including all file metadata,
         * status, and download URL.
         * @param fileId
         * @returns FilesGetResponse Ok
         * @throws ApiError
         */
        public static getFile(
            fileId: string,
        ): CancelablePromise<FilesGetResponse> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/files/{fileId}',
                path: {
                    'fileId': fileId,
                },
                errors: {
                    401: `Unauthorized`,
                    403: `Forbidden`,
                    404: `Resource not found`,
                    500: `Internal Server Error`,
                },
            });
        }
        /**
         * Update file metadata and tags.
         *
         * Updates the metadata and tags of an existing file. Only fields provided in the request body
         * will be updated. This is useful for adding tags or updating file metadata without changing the content.
         *
         * **Example usage:**
         * PUT /api/v1/files/file_123
         * {
             * "tags": { "processed": "true", "category": "documents" }
             * }
             * @param fileId
             * @param requestBody
             * @returns FilesUpdateResponse Ok
             * @throws ApiError
             */
            public static updateFile(
                fileId: string,
                requestBody: FilesUpdateBodyParams,
            ): CancelablePromise<FilesUpdateResponse> {
                return __request(OpenAPI, {
                    method: 'PUT',
                    url: '/api/files/{fileId}',
                    path: {
                        'fileId': fileId,
                    },
                    body: requestBody,
                    mediaType: 'application/json',
                    errors: {
                        401: `Unauthorized`,
                        403: `Forbidden`,
                        404: `Resource not found`,
                        500: `Internal Server Error`,
                    },
                });
            }
            /**
             * Delete a file by ID.
             *
             * Permanently deletes a file and all associated metadata. The file content will be removed
             * from storage. This action cannot be undone.
             * @param fileId
             * @returns FilesDeleteResponse Ok
             * @throws ApiError
             */
            public static deleteFile(
                fileId: string,
            ): CancelablePromise<FilesDeleteResponse> {
                return __request(OpenAPI, {
                    method: 'DELETE',
                    url: '/api/files/{fileId}',
                    path: {
                        'fileId': fileId,
                    },
                    errors: {
                        401: `Unauthorized`,
                        403: `Forbidden`,
                        404: `Resource not found`,
                        500: `Internal Server Error`,
                    },
                });
            }
            /**
             * Create a direct file upload session.
             *
             * Creates a pending file record and returns a presigned S3 PUT URL. Clients must
             * upload the raw file bytes using the returned `uploadUrl` and `uploadHeaders`,
             * then call the finalize endpoint.
             * @param requestBody
             * @returns FilesCreateUploadSessionResponse Ok
             * @throws ApiError
             */
            public static createUploadSession(
                requestBody: FilesCreateUploadSessionBodyParams,
            ): CancelablePromise<FilesCreateUploadSessionResponse> {
                return __request(OpenAPI, {
                    method: 'POST',
                    url: '/api/files/upload-sessions',
                    body: requestBody,
                    mediaType: 'application/json',
                    errors: {
                        401: `Unauthorized`,
                        403: `Forbidden`,
                        500: `Internal Server Error`,
                    },
                });
            }
            /**
             * Finalize a direct file upload session.
             *
             * Verifies that the uploaded S3 object matches the expected size, content type,
             * and checksum, then marks the file ready and returns the normal file payload.
             * @param uploadSessionId
             * @returns FilesFinalizeUploadSessionResponse Ok
             * @throws ApiError
             */
            public static finalizeUploadSession(
                uploadSessionId: string,
            ): CancelablePromise<FilesFinalizeUploadSessionResponse> {
                return __request(OpenAPI, {
                    method: 'POST',
                    url: '/api/files/upload-sessions/{uploadSessionId}/finalize',
                    path: {
                        'uploadSessionId': uploadSessionId,
                    },
                    errors: {
                        401: `Unauthorized`,
                        403: `Forbidden`,
                        404: `Resource not found`,
                        500: `Internal Server Error`,
                    },
                });
            }
        }
